export enum SessionStatus {
  AVAILABLE = 'AVAILABLE',
  COMPLETED = 'COMPLETED',
}
